import Grid from '@/global/components/ui/Grid'
import {
    FormDatePicker,
    FormField,
    FormFieldCheckbox,
    FormFieldSelect,
} from 'global/components/Form'
import { ChangeEventHandler } from 'react'
import { useFormContext } from 'react-hook-form'
import { reps } from 'service/api'
import { useMemoMarcas } from '../../service/marcas'

interface IProps {
    isEdicao?: boolean
}

export default function FormReps({ isEdicao }: IProps) {
    const { data: marcas } = reps.marca.useFetch()
    const { disabled, required } = useMemoMarcas()
    const { setValue } = useFormContext()

    const handleChangeIp: ChangeEventHandler<HTMLInputElement> = event => {
        const { value } = event.target
        const octetos = value.split('.')

        if (octetos.length > 4) {
            setValue(
                'ip',
                `${octetos[0]}.${octetos[1]}.${octetos[2]}.${octetos[3]}`,
            )
            return
        }

        const newValue = value
            .replace(/[^0-9.]/, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})/, '$1.$2')
            .replace(/(-\d{1,2})\d+?$/, '$1')

        setValue('ip', newValue)
    }

    return (
        <Grid container>
            <Grid item xs={4}>
                <FormFieldSelect
                    label="Marcas"
                    name="marcaId"
                    disabled={isEdicao}
                    options={marcas?.map(marca => ({
                        value: marca.id,
                        label: marca.nome,
                    }))}
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="numeroSerie"
                    label="Número de série"
                    disabled={disabled.numeroSerie}
                    required={required.numeroSerie}
                />
            </Grid>
            <Grid item xs={4}>
                <FormDatePicker
                    name="dataInicial"
                    label="Data inicial"
                    type="date"
                />
            </Grid>
            <Grid item xs={4}>
                <FormField name="nome" label="Nome" autoComplete="off" />
            </Grid>
            <Grid item xs={3}>
                <FormField
                    name="ultimoNsr"
                    label="Ultimo NSR"
                    type="number"
                    disabled={disabled.ultimoNsr}
                    required={required.ultimoNsr}
                />
            </Grid>
            <Grid item xs={3}>
                <FormField
                    name="ip"
                    label="IP"
                    disabled={disabled.ip}
                    required={required.ip}
                    onChange={handleChangeIp}
                />
            </Grid>
            <Grid item xs={2}>
                <FormField
                    name="porta"
                    label="Porta"
                    disabled={disabled.porta}
                    required={required.porta}
                />
            </Grid>
            <Grid item xs={5}>
                <FormField
                    name="usuario"
                    label="Usuário"
                    disabled={disabled.usuario}
                    required={required.usuario}
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="senha"
                    label="Senha"
                    disabled={disabled.senha}
                    required={required.senha}
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldCheckbox name="portaria671" label="Portaria 671" />
            </Grid>
        </Grid>
    )
}
